import { useQuery } from '@tanstack/react-query';

import { PageViewContentType, PageViewPeriod, pageViewsApi } from '@/services';

const STALE_TIME = 5 * 60 * 1000;

export const pageViewsKeys = {
  totals: (contentType?: PageViewContentType) => ['page-views', 'totals', contentType ?? 'all'] as const,
  stats: (period: PageViewPeriod, contentType?: PageViewContentType) =>
    ['page-views', 'stats', period, contentType ?? 'all'] as const,
  top: (contentType: PageViewContentType, period: PageViewPeriod) =>
    ['page-views', 'top', contentType, period] as const,
};

export function usePageViewTotalsQuery(contentType?: PageViewContentType) {
  return useQuery({
    queryKey: pageViewsKeys.totals(contentType),
    queryFn: () => pageViewsApi.getTotals(contentType),
    staleTime: STALE_TIME,
  });
}

export function usePageViewStatsQuery(period: PageViewPeriod, contentType?: PageViewContentType) {
  return useQuery({
    queryKey: pageViewsKeys.stats(period, contentType),
    queryFn: () => pageViewsApi.getStats(period, contentType),
    staleTime: STALE_TIME,
  });
}

export function usePageViewTopQuery(contentType: PageViewContentType, period: PageViewPeriod) {
  return useQuery({
    queryKey: pageViewsKeys.top(contentType, period),
    queryFn: () => pageViewsApi.getTop(contentType, period, 10),
    staleTime: STALE_TIME,
  });
}
